// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__6yr-8","modalFooterButton":"ModalNotes_modalFooterButton__qk7nE"};